import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/css/colors-static.css'
import '@/assets/css/colors-custom.css'
import '@/assets/css/kendo.css'
import '../theme/index.css'
import './assets/css/tailwind.css'
import vueNumeralFilterInstaller from 'vue-numeral-filter'
import { i18n } from '@/i18n'
import ElementUI from 'element-ui'
import localeES from 'element-ui/lib/locale/lang/es'
import localeEN from 'element-ui/lib/locale/lang/en'
import localeDE from 'element-ui/lib/locale/lang/de'
import localeFR from 'element-ui/lib/locale/lang/fr'
import localeCA from 'element-ui/lib/locale/lang/ca'
import { Outside } from '@/components/directives/Outside.js'
import { feedbackMixin, numberFilter } from '@/mixins/appMixin'
import { getDateFormat } from '@/i18n/dates'
import '@/components/base/_globals'
import 'nprogress/nprogress.css'
import VueFilterDateFormat from 'vue-filter-date-format'

import { load } from '@progress/kendo-vue-intl'
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json'
import currencyData from 'cldr-core/supplemental/currencyData.json'
import weekData from 'cldr-core/supplemental/weekData.json'
import numbersEs from 'cldr-numbers-full/main/es/numbers.json'
import currenciesEs from 'cldr-numbers-full/main/es/currencies.json'
import caGregorianEs from 'cldr-dates-full/main/es/ca-gregorian.json'
import dateFieldsEs from 'cldr-dates-full/main/es/dateFields.json'
import timeZoneNamesEs from 'cldr-dates-full/main/es/timeZoneNames.json'
import numbersEn from 'cldr-numbers-full/main/en/numbers.json'
import currenciesEn from 'cldr-numbers-full/main/en/currencies.json'
import caGregorianEn from 'cldr-dates-full/main/en/ca-gregorian.json'
import dateFieldsEn from 'cldr-dates-full/main/en/dateFields.json'
import timeZoneNamesEn from 'cldr-dates-full/main/en/timeZoneNames.json'
import numbersFr from 'cldr-numbers-full/main/fr/numbers.json'
import currenciesFr from 'cldr-numbers-full/main/fr/currencies.json'
import caGregorianFr from 'cldr-dates-full/main/fr/ca-gregorian.json'
import dateFieldsFr from 'cldr-dates-full/main/fr/dateFields.json'
import timeZoneNamesFr from 'cldr-dates-full/main/fr/timeZoneNames.json'
import numbersDe from 'cldr-numbers-full/main/de/numbers.json'
import currenciesDe from 'cldr-numbers-full/main/de/currencies.json'
import caGregorianDe from 'cldr-dates-full/main/de/ca-gregorian.json'
import dateFieldsDe from 'cldr-dates-full/main/de/dateFields.json'
import timeZoneNamesDe from 'cldr-dates-full/main/de/timeZoneNames.json'
import numbersCa from 'cldr-numbers-full/main/ca/numbers.json'
import currenciesCa from 'cldr-numbers-full/main/ca/currencies.json'
import caGregorianCa from 'cldr-dates-full/main/ca/ca-gregorian.json'
import dateFieldsCa from 'cldr-dates-full/main/ca/dateFields.json'
import timeZoneNamesCa from 'cldr-dates-full/main/ca/timeZoneNames.json'
import 'vue-loading-overlay/dist/vue-loading.css'

import VueYoutube from 'vue-youtube'
import IdleVue from 'idle-vue'
import VueTour from 'vue-tour'

import 'vue-pdf-app/dist/icons/main.css'
import VuePdfApp from 'vue-pdf-app'

require('vue-tour/dist/vue-tour.css')

load(
  likelySubtags,
  currencyData,
  weekData,
  numbersEs,
  currenciesEs,
  caGregorianEs,
  dateFieldsEs,
  timeZoneNamesEs,
  numbersEn,
  currenciesEn,
  caGregorianEn,
  dateFieldsEn,
  timeZoneNamesEn,
  numbersFr,
  currenciesFr,
  caGregorianFr,
  dateFieldsFr,
  timeZoneNamesFr,
  numbersDe,
  currenciesDe,
  caGregorianDe,
  dateFieldsDe,
  timeZoneNamesDe,
  numbersCa,
  currenciesCa,
  caGregorianCa,
  dateFieldsCa,
  timeZoneNamesCa
)

Vue.config.productionTip = false

Vue.directive('outside', Outside)
Vue.use(VueFilterDateFormat)

Vue.mixin(feedbackMixin)
Vue.mixin(numberFilter)
Vue.filter('date', getDateFormat)

Vue.use(VueYoutube)
Vue.use(VueTour)
Vue.component('vue-pdf-app', VuePdfApp)

export const bus = new Vue()

const eventsHub = new Vue()
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: (process.env.VUE_APP_IDLE_TIME * 1000 * 60), // Minutos
  // idleTime: (process.env.VUE_APP_IDLE_TIME * 1000), // Segundos
  startAtIdle: false
})



// Configuración inicial de Vue y los plugins
Vue.use(ElementUI, { locale: localeES })
Vue.use(vueNumeralFilterInstaller, { locale: 'es-es' })

new Vue({
  router,
  i18n,
  store,
  watch: {
    // Cambiar el idioma cuando cambia el locale de i18n
    '$i18n.locale': function (newVal, oldVal) {
      let locale, numeralLocale

      switch (newVal) {
        case 'es':
          locale = localeES
          numeralLocale = 'es-es'
          break
        case 'ca':
          locale = localeCA
          numeralLocale = 'ca-ca'
          break
        case 'de':
          locale = localeDE
          numeralLocale = 'de-de'
          break
        case 'en-GB':
          locale = localeEN
          numeralLocale = 'en-gb'
          break
        case 'fr':
          locale = localeFR
          numeralLocale = 'fr-fr'
          break
        default:
          locale = localeES
          numeralLocale = 'es-es'
      }

      // Cambia el idioma de Element UI
      ElementUI.locale(locale)

      // Cambia el idioma de vueNumeralFilterInstaller
      Vue.use(vueNumeralFilterInstaller, { locale: numeralLocale })
    }
  },
  render: h => h(App)
}).$mount('#app')

var mediaQuery = '(max-width: 1023px)'
window.matchMedia(mediaQuery).addEventListener('change', function () {
  var matched = this.matches
  store.dispatch('app/setIsLower1024', matched)
})
store.dispatch('app/setIsLower1024', window.matchMedia(mediaQuery).matches)
var mediaQuery2 = '(max-width: 1649px)'
window.matchMedia(mediaQuery2).addEventListener('change', function () {
  var matched = this.matches
  store.dispatch('app/setIsLower1650', matched)
})
store.dispatch('app/setIsLower1650', window.matchMedia(mediaQuery2).matches)
